var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecreationalCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6408 39.644V61.5325C41.7927 60.2365 38.2886 55.8204 38.2886 50.5883C38.2406 45.3562 41.7927 40.9401 46.6408 39.644Z",
    fill: "#FFAE4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 60.9095V41.373C13.3731 41.7571 17.3572 45.9811 17.3572 51.1653C17.4052 56.3014 13.4211 60.5255 8.33301 60.9095Z",
    fill: "#FFAE4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8135 50.539C32.8135 58.7952 38.8136 65.7073 46.6378 67.0994V80.2996C46.6378 82.7957 44.6218 84.8117 42.1257 84.8117H19.3732C13.2771 84.8117 8.33301 79.8676 8.33301 73.7715V66.3793C16.3972 65.9953 22.8293 59.2752 22.8293 51.163C22.8293 43.0028 16.3972 36.3307 8.33301 35.8987V28.5065C8.33301 22.4104 13.2771 17.4663 19.3732 17.4663H42.1257C44.6218 17.4663 46.6378 19.4824 46.6378 21.9784V34.0267C38.7656 35.4187 32.8135 42.2828 32.8135 50.539Z",
    fill: "#FFAE4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4082 61.2966V39.8882C57.8243 41.4242 60.9924 45.6483 60.9924 50.5924C60.9924 55.5365 57.7763 59.7126 53.4082 61.2966Z",
    fill: "#FFAE4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6644 42.9092V59.3735C87.1043 59.3735 83.4082 55.6775 83.4082 51.1654C83.4082 46.6053 87.1043 42.9092 91.6644 42.9092Z",
    fill: "#FFAE4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6672 28.5065V37.4347C85.8591 37.4347 80.5309 41.0348 78.7068 46.5549C75.5868 56.0111 82.595 64.7953 91.6672 64.7953V73.7235C91.6672 79.8196 86.7231 84.7637 80.6269 84.7637H57.8744C55.3784 84.7637 53.3623 82.7477 53.3623 80.2516V66.9554C60.8505 65.2273 66.4186 58.5552 66.4186 50.539C66.4186 42.5228 60.8505 35.8507 53.3623 34.1707V21.9784C53.3623 19.4824 55.3784 17.4663 57.8744 17.4663H80.6269C86.7231 17.4663 91.6672 22.4104 91.6672 28.5065Z",
    fill: "#FFAE4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecreationalCount);
export default __webpack_public_path__ + "static/media/recreational_count.3297b73569437e56cda6722c00b5a9e7.svg";
export { ForwardRef as ReactComponent };